import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sessionExpired } from '../redux/slices/authSlice';

// The axios interceptor lives outside React, so it signals via a DOM event.
// This component listens and pushes the result into Redux.
const SessionWatcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handle = () => dispatch(sessionExpired());
    window.addEventListener('creditflow:session-expired', handle);
    return () => window.removeEventListener('creditflow:session-expired', handle);
  }, [dispatch]);

  return null;
};

export default SessionWatcher;
